import axiosClient from "./axiosClient";
import https from "https";

import ConstData from "../ConstData";

let options = {};

// 20261023 재인증 비밀번호는 요청 본문에만 전달하고 Redux나 로그에 저장하지 않는다.
export const reset_report_token = ({ localServerSeq, userSeq, password }) => axiosClient.post(
    `/local-update/${localServerSeq}/token/reset`,
    { userSeq, password, confirmServerSeq: localServerSeq }, { ...options, timeout: 10000 });

if (ConstData.IS_LOCAL_VERSION) {
    options = {
        httpsAgent: new https.Agent({
            rejectUnauthorized: false, // 허가되지 않은 인증을 reject하지 않겠다!
        })
    }
}

// 260812 이 페이지를 서빙한 로컬 서버 자신의 정보를 조회한다. 8000·8001 양쪽에 등록되어 있어
// axiosClient 기본 베이스로 그냥 부르면 된다. 응답: { serverInfo: { serverSeq, localIp, ... } }
export const get_local_info = () => {
    console.log("api get local info:)");

    return axiosClient.get(`/local/localInfo`, options);
}

export const get_local_server_info_by_seq = ({ localServerSeq }) => {
    console.log("api get local server info by seq:) localServerSeq[", localServerSeq, "]");

    return axiosClient.get(`/local/${localServerSeq}`, options);
}

export const check_local_server_auth_code = ({ authCode }) => {
    console.log("api check local server auth code:) authCode[", authCode, "]");

    return axiosClient.get(`/local/code?kind=check-code&authCode=${authCode}`, options);
}

export const create_local_server_auth_code = () => {
    console.log("api create local server auth code:)");

    return axiosClient.get(`/local/code?kind=create-code`, options);
}

export const create_local_server = ({ serverName, subDomainSeq, localSiteSeq, localSiteName, localServerType }) => {
    console.log("api create local server info:) subDomainSeq[", subDomainSeq, "], serverName[", serverName, "]");
    console.log("api create local server info:) localSiteSeq[", localSiteSeq, "], localSiteName[", localSiteName, "]");

    return axiosClient.post(`/local`, {
        serverName,
        subDomainSEQ: subDomainSeq,
        localSiteSEQ: localSiteSeq,
        // 20260814 생성 화면에서 선택한 클라우드 관리용 서버 타입을 전달한다.
        localServerType
    }, options);
}

export const remove_local_server = ({ subDomainSeq, serverSeq }) => {
    console.log("api remove local server info:) subDomainSeq[", subDomainSeq, "], serverSeq[", serverSeq, "]");

    return axiosClient.delete(`/local`, options);
}

// 20260828 관리자 화면에서 로컬 서버 이름만 수정한다.
export const change_local_server_name = ({ localServerSeq, localServerName }) => {
    console.log("api change local server name:) localServerSeq[", localServerSeq, "], localServerName[", localServerName, "]");

    return axiosClient.put(`/local/${localServerSeq}/name`, {
        serverName: localServerName
    }, options);
}

export const change_local_site_info = ({ localServerSeq, localSiteSeq }) => {
    console.log("api change local site info:) localServerSeq[", localServerSeq, "], localSiteSeq[", localSiteSeq, "]");

    return axiosClient.put(`/local/${localServerSeq}/site`, {
        localSiteSEQ: localSiteSeq
    }, options);
}

export const change_local_server_port_info = ({ localServerSeq, portNumber, historySeq, historyMemo, status, routingKey }) => {
    console.log("api change local server port info:) localServerSeq[", localServerSeq, "], portNumber[", portNumber, "], status[", status, "]");
    console.log("api change local server port info:) historySeq[", historySeq, "], historyMemo[", historyMemo, "]");
    console.log("api change local server port info:) routingKey[", routingKey, "]");

    if (status) {
        return axiosClient.put(`/local/${localServerSeq}/port`, {
            portNumber,
            historyMemo,
            status,
            routingKey
        }, options);
    } else {
        return axiosClient.put(`/local/${localServerSeq}/port`, {
            historySEQ: historySeq,
            status,
            routingKey
        }, options);
    }
}

// 260804 로컬서버 상세설정(로그인 허용/자동 로그인/업데이트 허용) 저장
export const change_local_server_config_info = ({ localServerSeq, allowLoginYn, autoLoginYn, updateAllowYn, classMonitorAllowYn, localServerType }) => {
    console.log("api change local server config info:) localServerSeq[", localServerSeq, "], allowLoginYn[", allowLoginYn, "], autoLoginYn[", autoLoginYn, "], updateAllowYn[", updateAllowYn, "]");

    return axiosClient.put(`/local/${localServerSeq}/config`, {
        allowLoginYN: allowLoginYn,
        autoLoginYN: autoLoginYn,
        updateAllowYN: updateAllowYn,
        // 20260813 기존 상세설정 저장 요청에 클래스 모니터 허용값을 함께 전달한다.
        classMonitorAllowYN: classMonitorAllowYn,
        // 20260814 상세설정의 서버 타입을 기존 저장 요청에 함께 전달한다.
        localServerType
    }, options);
}

// 20260814 클라우드 관리자용 로컬 서버 타입 기준정보를 조회한다.
export const get_local_server_types = () => {
    return axiosClient.get(`/local/server-types`, options);
}

// 20260814 서버 타입의 신규 선택 가능 여부만 변경한다.
export const update_local_server_type_use = ({ localServerType, useYn }) => {
    return axiosClient.put(`/local/server-types/${localServerType}`, {
        useYN: useYn
    }, options);
}

export const get_local_site_list = () => {
    console.log("api get local site list:)");

    return axiosClient.get(`/local/site-list`, options);
}

export const create_local_site = ({ localSiteName }) => {
    console.log("api create local site info:) localSiteName[", localSiteName, "]");

    return axiosClient.post(`/local-site`, {
        localSiteName
    }, options);
}

export const delete_local_site = ({ localSiteSeq }) => {
    console.log("api delete local site info:) localSiteSeq[", localSiteSeq, "]");

    return axiosClient.delete(`/local-site/${localSiteSeq}`, options);
}

// 20260828 관리자 화면에서 로컬 사이트 이름을 수정한다.
export const change_local_site_name = ({ localSiteSeq, localSiteName }) => {
    console.log("api change local site name:) localSiteSeq[", localSiteSeq, "], localSiteName[", localSiteName, "]");

    return axiosClient.put(`/local-site/${localSiteSeq}/name`, {
        localSiteName
    }, options);
}

export const class_open_on_local_site = ({ localSiteSeq, openLocalSiteSeq }) => {
    console.log("api class open on local site:) localSiteSeq[", localSiteSeq, "], openLocalSiteSeq[", openLocalSiteSeq, "]");

    return axiosClient.post(`/local-site/${localSiteSeq}/${openLocalSiteSeq}?kind=open`, options);
}

export const class_close_on_local_site = ({ localSiteSeq, openLocalSiteSeq }) => {
    console.log("api class close on local site:) localSiteSeq[", localSiteSeq, "], openLocalSiteSeq[", openLocalSiteSeq, "]");

    return axiosClient.delete(`/local-site/${localSiteSeq}/${openLocalSiteSeq}?kind=close`, options);
}

// 20260814 변경된 서버 타입 사용 여부를 하나의 요청으로 일괄 저장한다.
export const update_local_server_types_use = ({ listLocalServerType }) => {
    return axiosClient.put(`/local/server-types`, {
        listLocalServerType
    }, options);
}

// 20260814 관리자 화면에서 로컬 서버의 업데이트 이력을 페이지 단위로 조회한다.
export const get_local_server_update_histories = ({ localServerSeq, limit, offset }) => {
    return axiosClient.get(`/local-update/${localServerSeq}/histories?limit=${limit}&offset=${offset}`, options);
}

// 20260814 업데이트 실행별 컴포넌트 상세 이력을 조회한다.
export const get_local_server_update_history = ({ localServerSeq, updateRunId }) => {
    return axiosClient.get(`/local-update/${localServerSeq}/histories/${encodeURIComponent(updateRunId)}`, options);
}

// 20260814 종료되지 않은 건과 비고를 포함한 포트 이력을 조회한다.
export const get_local_server_port_histories = ({ localServerSeq, limit, offset }) => {
    return axiosClient.get(`/local/${localServerSeq}/port-histories?limit=${limit}&offset=${offset}`, options);
}

// 20260828 관리자 명령 capability/ACK 상태를 조회한다.
export const get_local_server_command_info = ({ localServerSeq }) => {
    return axiosClient.get(`/local/${localServerSeq}/commands`, options);
}

// 20260828 관리자 명령을 로컬 서버 전용 MQ로 발행한다.
export const send_local_server_command = ({ localServerSeq, commandName, codecs, replyRoutingKey }) => {
    return axiosClient.post(`/local/${localServerSeq}/commands`, {
        commandName,
        codecs,
        replyRoutingKey
    }, options);
}
